import { apiClient } from './api';

export type UserRole =
  | 'Admin'
  | 'Sales Rep'
  | 'Driver'
  | 'Warehouse Manager'
  | 'Call Center'
  | 'Customer';

export interface User {
  id: number;
  email: string;
  full_name: string;
  role: UserRole;
  is_active: boolean;
  phone?: string | null;
  employee_id?: string | null;
  department?: string | null;
  territory?: string | null;
  warehouse_code?: string | null;
  notes?: string | null;
  created_at: string;
}

export interface UserCreateInput {
  email: string;
  password: string;
  full_name: string;
  role: UserRole;
  phone?: string;
  employee_id?: string;
  department?: string;
  territory?: string;
  warehouse_code?: string;
  notes?: string;
}

export interface UserUpdateInput {
  email?: string;
  full_name?: string;
  role?: UserRole;
  phone?: string | null;
  employee_id?: string | null;
  department?: string | null;
  territory?: string | null;
  warehouse_code?: string | null;
  notes?: string | null;
}

export interface PaginatedUsers {
  users: User[];
  pagination: { total: number; page: number; limit: number; pages: number };
}

export async function listUsers(page = 1, limit = 100): Promise<PaginatedUsers> {
  return apiClient.get<PaginatedUsers>('/users', { page, limit });
}

export async function createUser(input: UserCreateInput): Promise<User> {
  return apiClient.post<User>('/users', input);
}

export async function updateUser(id: number, input: UserUpdateInput): Promise<User> {
  return apiClient.put<User>(`/users/${id}`, input);
}

export async function deactivateUser(id: number): Promise<User> {
  return apiClient.patch<User>(`/users/${id}/deactivate`);
}

export async function activateUser(id: number): Promise<User> {
  return apiClient.patch<User>(`/users/${id}/activate`);
}

export async function deleteUser(id: number): Promise<void> {
  await apiClient.delete<void>(`/users/${id}`);
}
